/** ISO instant -> the 'YYYY-MM-DDTHH:mm' a datetime-local input wants, in org time. */
export function toLocalInput(iso: string, timezone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(new Date(iso))
  const map: Record<string, string> = {}
  for (const p of parts) map[p.type] = p.value
  return `${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}`
}

/**
 * The inverse. Two passes settle the UTC offset, including across a DST change,
 * without pulling in a timezone library.
 */
export function fromLocalInput(value: string, timezone: string): string {
  const [datePart, timePart] = value.split('T')
  const [y, m, d] = datePart.split('-').map(Number)
  const [hh, mm] = timePart.split(':').map(Number)
  const target = Date.UTC(y, m - 1, d, hh, mm)

  const offsetAt = (ms: number) => {
    const iso = toLocalInput(new Date(ms).toISOString(), timezone)
    const [dp, tp] = iso.split('T')
    const [yy, mo, dd] = dp.split('-').map(Number)
    const [h2, m2] = tp.split(':').map(Number)
    return Date.UTC(yy, mo - 1, dd, h2, m2) - ms
  }

  let ts = target - offsetAt(target)
  ts = target - offsetAt(ts)
  return new Date(ts).toISOString()
}
